/* ═══════════════════════════════════════════════════════════════════
   RECHERCHE PRÉDICTIVE — Le Cellier Morvandiau
   ═══════════════════════════════════════════════════════════════════
   Greffe des suggestions en cours de frappe sur TOUTES les barres de
   recherche du site (méga-menu, menu mobile, page /search, page 404,
   bandeau du catalogue). Aucune n'est modifiée dans le HTML : si ce
   fichier ne se charge pas, chaque formulaire continue de fonctionner
   normalement en soumettant vers /search.

   Deux groupes de suggestions, dans cet ordre :
     1. les RAYONS (collections) — « chabl » propose le rayon Chablis et
        ses 16 vins, ce qu'une liste de 4 bouteilles ne donnerait pas ;
     2. les VINS (produits).

   L'API interrogée est /search/suggest.json (Predictive Search de
   Shopify). Les propriétés cherchées sont réglées explicitement sur
   titre + type + producteur + étiquette : sur cette boutique les
   appellations sont des étiquettes, donc « premier cru » ou
   « cote-de-beaune » doivent matcher.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var CFG = window.CellierRecherche || {};
  var URL_SUGGEST  = CFG.urlSuggest  || '/search/suggest.json';
  var URL_RECHERCHE = CFG.urlRecherche || '/search';
  var DEVISE = CFG.devise || 'EUR';

  var MIN_CARACTERES = 2;
  var DELAI_FRAPPE   = 220;   // ms
  var NB_RAYONS      = 3;
  var NB_VINS        = 6;

  var compteurId = 0;

  /* ── Prix ────────────────────────────────────────────────────────
     L'API renvoie le prix en CENTIMES sous forme de nombre (12900),
     et certaines versions sous forme de chaîne (« 129.00 »). On gère
     les deux. Filet de sécurité : en dessous de 1 €, on n'affiche
     rien — aucune bouteille de la cave ne coûte moins d'un euro, donc
     un tel résultat signifierait qu'on a mal interprété l'unité, et
     mieux vaut ne pas afficher de prix qu'en afficher un faux. */
  var formateur = null;
  try {
    formateur = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: DEVISE });
  } catch (e) { formateur = null; }

  function formatPrix(valeur) {
    var centimes;
    if (typeof valeur === 'number' && isFinite(valeur)) {
      centimes = Math.round(valeur);
    } else if (typeof valeur === 'string' && valeur !== '') {
      if (valeur.indexOf('.') !== -1 || valeur.indexOf(',') !== -1) {
        var f = parseFloat(valeur.replace(',', '.'));
        if (!isFinite(f)) return '';
        centimes = Math.round(f * 100);
      } else {
        var n = parseInt(valeur, 10);
        if (!isFinite(n)) return '';
        centimes = n;
      }
    } else {
      return '';
    }
    if (centimes < 100) return '';
    var euros = centimes / 100;
    if (formateur) return formateur.format(euros);
    return euros.toFixed(2).replace('.', ',') + ' €';
  }

  /* ── Vignette ────────────────────────────────────────────────────
     On demande une petite image au CDN plutôt que l'originale. */
  function vignette(produit) {
    var src = (produit.featured_image && produit.featured_image.url) || produit.image;
    if (!src || typeof src !== 'string') return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=120';
  }

  /* ── Construction du panneau ─────────────────────────────────────
     Tout le texte est posé via textContent : aucune interpolation
     HTML, donc aucun risque d'injection depuis les titres produits. */
  function creerLigne(url, id) {
    var a = document.createElement('a');
    a.className = 'rp-item';
    a.href = url;
    a.id = id;
    a.setAttribute('role', 'option');
    a.setAttribute('aria-selected', 'false');
    return a;
  }

  function ligneRayon(collection, id) {
    var a = creerLigne(collection.url, id);
    a.classList.add('rp-item--rayon');

    var puce = document.createElement('span');
    puce.className = 'rp-item-puce';
    puce.setAttribute('aria-hidden', 'true');
    puce.textContent = '◈';
    a.appendChild(puce);

    var corps = document.createElement('span');
    corps.className = 'rp-item-corps';
    var titre = document.createElement('span');
    titre.className = 'rp-item-titre';
    titre.textContent = collection.title || '';
    corps.appendChild(titre);
    var meta = document.createElement('span');
    meta.className = 'rp-item-meta';
    meta.textContent = 'Voir le rayon';
    corps.appendChild(meta);
    a.appendChild(corps);
    return a;
  }

  function ligneVin(produit, id) {
    var a = creerLigne(produit.url, id);

    var src = vignette(produit);
    if (src) {
      var img = document.createElement('img');
      img.className = 'rp-item-img';
      img.src = src;
      img.alt = '';
      img.width = 40;
      img.height = 40;
      img.loading = 'lazy';
      a.appendChild(img);
    } else {
      var vide = document.createElement('span');
      vide.className = 'rp-item-img rp-item-img--vide';
      vide.setAttribute('aria-hidden', 'true');
      a.appendChild(vide);
    }

    var corps = document.createElement('span');
    corps.className = 'rp-item-corps';

    var titre = document.createElement('span');
    titre.className = 'rp-item-titre';
    titre.textContent = produit.title || '';
    corps.appendChild(titre);

    var bas = document.createElement('span');
    bas.className = 'rp-item-meta';
    var morceaux = [];
    if (produit.vendor) morceaux.push(produit.vendor);
    var prix = formatPrix(produit.price);
    if (prix) morceaux.push(prix);
    bas.textContent = morceaux.join(' · ');
    corps.appendChild(bas);

    a.appendChild(corps);

    if (produit.available === false) {
      var epuise = document.createElement('span');
      epuise.className = 'rp-item-epuise';
      epuise.textContent = 'Épuisé';
      a.appendChild(epuise);
    }
    return a;
  }

  function titreGroupe(texte) {
    var p = document.createElement('p');
    p.className = 'rp-groupe';
    p.setAttribute('role', 'presentation');
    p.textContent = texte;
    return p;
  }

  /* ── Une instance par formulaire ─────────────────────────────── */
  function brancher(form) {
    var input = form.querySelector('input[name="q"]');
    if (!input || input.dataset.rpBranche === '1') return;
    input.dataset.rpBranche = '1';

    var idPanneau = 'rp-panneau-' + (++compteurId);

    var panneau = document.createElement('div');
    panneau.className = 'rp-panneau';
    panneau.id = idPanneau;
    panneau.setAttribute('role', 'listbox');
    panneau.setAttribute('aria-label', 'Suggestions de recherche');
    panneau.hidden = true;

    var annonce = document.createElement('span');
    annonce.className = 'visually-hidden';
    annonce.setAttribute('aria-live', 'polite');

    form.classList.add('rp-form');
    form.appendChild(panneau);
    form.appendChild(annonce);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', idPanneau);
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');

    var lignes = [];
    var actif = -1;
    var minuteur = null;
    var enCours = null;
    var dernierTerme = '';

    function fermer() {
      panneau.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      actif = -1;
    }

    function surligner(i) {
      if (actif >= 0 && lignes[actif]) {
        lignes[actif].classList.remove('is-actif');
        lignes[actif].setAttribute('aria-selected', 'false');
      }
      actif = i;
      if (actif >= 0 && lignes[actif]) {
        lignes[actif].classList.add('is-actif');
        lignes[actif].setAttribute('aria-selected', 'true');
        input.setAttribute('aria-activedescendant', lignes[actif].id);
        if (lignes[actif].scrollIntoView) {
          lignes[actif].scrollIntoView({ block: 'nearest' });
        }
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function afficher(terme, rayons, vins) {
      panneau.textContent = '';
      lignes = [];
      actif = -1;

      if (!rayons.length && !vins.length) {
        var vide = document.createElement('p');
        vide.className = 'rp-vide';
        vide.textContent = 'Aucune suggestion pour « ' + terme + ' »';
        panneau.appendChild(vide);
        annonce.textContent = 'Aucune suggestion';
      } else {
        if (rayons.length) {
          panneau.appendChild(titreGroupe(rayons.length > 1 ? 'Rayons' : 'Rayon'));
          rayons.forEach(function (c, i) {
            var l = ligneRayon(c, idPanneau + '-r' + i);
            panneau.appendChild(l);
            lignes.push(l);
          });
        }
        if (vins.length) {
          panneau.appendChild(titreGroupe(vins.length > 1 ? 'Vins' : 'Vin'));
          vins.forEach(function (p, i) {
            var l = ligneVin(p, idPanneau + '-v' + i);
            panneau.appendChild(l);
            lignes.push(l);
          });
        }
        annonce.textContent = lignes.length + ' suggestion' + (lignes.length > 1 ? 's' : '');
      }

      /* Dernière ligne : la recherche complète, toujours proposée —
         les suggestions sont plafonnées, les résultats ne le sont pas. */
      var tout = creerLigne(
        URL_RECHERCHE + '?type=product&options%5Bprefix%5D=last' +
        '&options%5Bunavailable_products%5D=last&q=' + encodeURIComponent(terme),
        idPanneau + '-tout'
      );
      tout.classList.add('rp-item--tout');
      var libelle = document.createElement('span');
      libelle.className = 'rp-item-corps';
      libelle.textContent = 'Voir tous les résultats pour « ' + terme + ' »';
      tout.appendChild(libelle);
      panneau.appendChild(tout);
      lignes.push(tout);

      panneau.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function interroger(terme) {
      if (enCours) { enCours.abort(); enCours = null; }

      var url = URL_SUGGEST +
        '?q=' + encodeURIComponent(terme) +
        '&resources%5Btype%5D=product,collection' +
        '&resources%5Blimit%5D=' + NB_VINS +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
        '&resources%5Boptions%5D%5Bfields%5D=title,product_type,vendor,tag';

      var ctrl = null;
      var options = {};
      if (typeof AbortController !== 'undefined') {
        ctrl = new AbortController();
        enCours = ctrl;
        options.signal = ctrl.signal;
      }

      fetch(url, options)
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          if (terme !== dernierTerme) return;   // réponse périmée
          var res = (data && data.resources && data.resources.results) || {};
          var rayons = (res.collections || []).slice(0, NB_RAYONS);
          var vins   = (res.products || []).slice(0, NB_VINS);
          afficher(terme, rayons, vins);
        })
        .catch(function () {
          /* Réseau coupé ou requête annulée : on ne montre rien.
             Le formulaire reste soumissible, donc l'utilisateur n'est
             jamais bloqué. */
          if (terme === dernierTerme) fermer();
        });
    }

    input.addEventListener('input', function () {
      var terme = input.value.trim();
      dernierTerme = terme;
      if (minuteur) clearTimeout(minuteur);
      if (terme.length < MIN_CARACTERES) { fermer(); return; }
      minuteur = setTimeout(function () { interroger(terme); }, DELAI_FRAPPE);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (!panneau.hidden) { e.stopPropagation(); fermer(); }
        return;
      }
      if (panneau.hidden || !lignes.length) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        surligner(actif + 1 >= lignes.length ? 0 : actif + 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        surligner(actif - 1 < 0 ? lignes.length - 1 : actif - 1);
      } else if (e.key === 'Enter') {
        if (actif >= 0 && lignes[actif]) {
          e.preventDefault();
          window.location.href = lignes[actif].href;
        }
      } else if (e.key === 'Tab') {
        fermer();
      }
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CARACTERES && lignes.length) {
        panneau.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    });

    /* Le clic doit passer AVANT le blur, sinon le panneau disparaît
       sous le doigt. On agit donc sur mousedown/touchstart. */
    panneau.addEventListener('mousedown', function (e) { e.preventDefault(); });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) fermer();
    });
  }

  /* ── Bouton « Rechercher » de la barre de navigation ─────────────
     Déplie une barre fixée sous la navigation, et rend le focus au
     bouton à la fermeture pour ne pas perdre les utilisateurs au
     clavier. */
  function brancherBouton() {
    var bouton = document.getElementById('navSearchToggle');
    var barre  = document.getElementById('navSearchBar');
    if (!bouton || !barre) return;
    var champ = barre.querySelector('input[name="q"]');

    function ouvrir() {
      barre.hidden = false;
      bouton.setAttribute('aria-expanded', 'true');
      bouton.classList.add('is-ouvert');
      if (champ) champ.focus();
    }
    function fermerBarre(rendreFocus) {
      barre.hidden = true;
      bouton.setAttribute('aria-expanded', 'false');
      bouton.classList.remove('is-ouvert');
      if (rendreFocus) bouton.focus();
    }

    bouton.addEventListener('click', function () {
      if (barre.hidden) { ouvrir(); } else { fermerBarre(true); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !barre.hidden) fermerBarre(true);
    });

    document.addEventListener('click', function (e) {
      if (barre.hidden) return;
      if (barre.contains(e.target) || bouton.contains(e.target)) return;
      fermerBarre(false);
    });
  }

  function init() {
    document.querySelectorAll('form[role="search"]').forEach(brancher);
    brancherBouton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.CellierRecherche = window.CellierRecherche || {};
  window.CellierRecherche.brancher = brancher;
})();
